"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCreator = void 0;
var utils_1 = require("../utils");
exports.updateCreator = (function (writeBatch) {
    return function (reference, data) {
        var ref = writeBatch.update(reference, 
        // @ts-expect-error
        (0, utils_1.flatten)(data));
        return ref;
    };
});
